import { render, staticRenderFns } from "./MessageWithAction.vue?vue&type=template&id=d51fc8ba&scoped=true&"
import script from "./MessageWithAction.vue?vue&type=script&lang=js&"
export * from "./MessageWithAction.vue?vue&type=script&lang=js&"
import style0 from "./MessageWithAction.vue?vue&type=style&index=0&id=d51fc8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51fc8ba",
  null
  
)

export default component.exports